import React, { useState, useEffect, useRef } from "react";
import axios from "../axios";
import "./JananiChat.css";

const API_URL = process.env.REACT_APP_API_URL;

const JananiChat = () => {
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  // Auto-scroll to bottom when new messages arrive
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Initial greeting
  useEffect(() => {
    const initialMessage = {
      text: "Hey there ❤️ I'm Janani. How are you doing today?",
      sender: "janani",
      timestamp: new Date().toISOString(),
    };
    setMessages([initialMessage]);

    // Focus input
    inputRef.current?.focus();
  }, []);

  const handleSendMessage = async (e) => {
    e.preventDefault();
    
    if (!inputMessage.trim()) return;

    const userMessage = {
      text: inputMessage,
      sender: "user",
      timestamp: new Date().toISOString(),
    };

    // Add user message
    setMessages((prev) => [...prev, userMessage]);
    setInputMessage("");
    setIsTyping(true);

    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.post(
        `${API_URL}api/chat/chat/`,
        { message: inputMessage },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Simulate typing delay for more natural feel
      setTimeout(() => {
        const jananiMessage = {
          text: response.data.reply,
          sender: "janani",
          timestamp: response.data.timestamp,
        };

        setMessages((prev) => [...prev, jananiMessage]);
        setIsTyping(false);
      }, 1000);
    } catch (error) {
      console.error("Error sending message:", error);
      
      const errorMessage = {
        text: "Sorry, I'm having trouble connecting right now 😔",
        sender: "janani",
        timestamp: new Date().toISOString(),
      };

      setMessages((prev) => [...prev, errorMessage]);
      setIsTyping(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage(e);
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="janani-page-wrapper">
      <div className="janani-chat-container">
        {/* Header */}
        <div className="janani-chat-header">
          <div className="janani-avatar">
            <div className="avatar-circle">
              <span className="avatar-emoji">💕</span>
              <div className="avatar-status"></div>
            </div>
          </div>
          <div className="janani-info">
            <h2 className="janani-name">Janani</h2>
            <p className="janani-status">
              {isTyping ? "typing..." : "Always here for you ❤️"}
            </p>
          </div>
        </div>

        {/* Messages Area */}
        <div className="janani-messages">
          {messages.map((msg, index) => (
            <div
              key={index}
              className={`message-wrapper ${msg.sender === "user" ? "user" : "janani"}`}
            >
              <div className="message-bubble">
                <p className="message-text">{msg.text}</p>
                <span className="message-time">{formatTime(msg.timestamp)}</span>
              </div>
            </div>
          ))}

          {/* Typing Indicator */}
          {isTyping && (
            <div className="message-wrapper janani">
              <div className="message-bubble typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}

          <div ref={messagesEndRef} />
        </div>

        {/* Input Area */}
        <form className="janani-input-area" onSubmit={handleSendMessage}>
          <div className="input-wrapper">
            <input
              ref={inputRef}
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Type your message..."
              className="message-input"
            />
            <button
              type="submit"
              className="send-button"
              disabled={!inputMessage.trim() || isTyping}
            >
              <span className="send-icon">
                {isTyping ? "⏳" : "💌"}
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JananiChat;